import { Component, OnInit, Output, Input, EventEmitter, ViewChild, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CarouselComponent, OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { FinanceService } from 'src/app/finance/finance.service';
import { GlobalService } from '../../services/global.service';
declare var AdobeDC: any;

@Component({
    selector: 'app-service-files-view',
    templateUrl: './service-files-view.component.html',
    styleUrls: ['./service-files-view.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServiceFilesViewComponent implements OnInit {

	@Input() service: any;
	@Input() files: any;
	@Input() type: string;
	@Input() fileNameProperty: string = 'file_name'
	@Input() fileUrlProperty: string = 'file_url';
	@Input() canEdit: boolean = true;
	@Output() notify = new EventEmitter<string>();
	@ViewChild('owlCar', { static: false }) owlCar: CarouselComponent;


	currentSlideIndex: any = 0;
	adobeDCView: Array<any> = [];
	loadingImage: Array<boolean> = [];
	loading: boolean = false;

	customOptions: OwlOptions = {
		loop: false,
		mouseDrag: false,
		touchDrag: false,
		pullDrag: false,
		dots: true,
		dotsSpeed: 1,
		dotsData: false,
		startPosition: 0,
		nav: false,
		dotsEach: true,
		navSpeed: 1,
		autoplay: false,
		autoplayTimeout: 4000,
		autoplayHoverPause: false,
		items: 1
	};

	view: string = 'home';

	onChangedCarousel(data: SlidesOutputData) {
		this.currentSlideIndex = data.startPosition;
		this.loadFileViewer(this.files[this.currentSlideIndex]);
	}

	sliderResponse(ev) {
		this.view = 'home';
		this.loading = true;
		if (ev.type == 'delete') {
			if (this.type == 'service') {
				this.deleteFileService(ev);
			} else if (this.type == 'catering') {
				this.deleteFileCatering(ev);
			}
		}
	}

	deleteFileService(ev) {
		let id = this.files[ev.position].id;
		this._fiS.deleteFileService(id).subscribe(
			data => {
				this.loading = false;
				this.notify.emit();
			}
		)
	}

	deleteFileCatering(ev) {
		let id = this.files[ev.position].id;
		this._fiS.deleteFileCatering(id).subscribe(
			data => {
				this.loading = false;
				this.notify.emit();
			}
		)
	}

	changeSlide(ev) {
		this.currentSlideIndex = ev;
	}

	onCloseSlider() {
		this.setView('home');
		this.owlCar.to(this.currentSlideIndex + '');
	}

	onInitializedCarousel(data: SlidesOutputData) {
		setTimeout(() => {
			// Loads first file, and it is neccesary since it could be a PDF!
			if (this.files.length) {
				this.currentSlideIndex = 0;
				this.loadFileViewer(this.files[this.currentSlideIndex]);
			}
		}, 200)
	}

	loadFileViewer(file) {
		if (file.fileExtension == 'pdf') {
			this.setPdfViewer(file);
		}
	}

	setPdfViewer(fileItem) {
		if (!this.adobeDCView[this.currentSlideIndex]) {
			this.adobeDCView[this.currentSlideIndex] = new AdobeDC.View({ clientId: this._gS.adobe_cred, divId: `adobe-dc-view-${fileItem.id}`, locale: "en-US" });

			var promise = this.adobeDCView[this.currentSlideIndex].previewFile({
				content: { location: { url: fileItem[this.fileUrlProperty] } },
				metaData: { fileName: fileItem[this.fileNameProperty] ? fileItem[this.fileNameProperty] : 'document.pdf' }
			}, { embedMode: "SIZED_CONTAINER" });
		}
	}

	setAdobeAndImageViewers() {
		this.adobeDCView = [];
		this.loadingImage = [];
		if (this.files.length) {
			for (let i = 0; i < this.files.length; i++) {
				this.adobeDCView.push(null);
				this.loadingImage.push(true);
			}
		}
	}

	setFilesExtensions() {
		for (const file of this.files) {
			file.fileExtension = this._gS.getFileExtension(file[this.fileNameProperty]);
		}
	}

	setView(ev) {
		this.view = ev;
	}

	constructor(public _gS: GlobalService, private _fiS: FinanceService) { }

	ngOnInit() {

	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.files) {
			this.setFilesExtensions();
			this.setAdobeAndImageViewers();
		}
	}
}
